import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';
import { filter, map, Observable, of } from 'rxjs';

import { NavigationMenuItemDto } from '@common/data-services/navigation/models/navigation-menu-item.dto';
import { environment } from '@environment';

import { SidenavService } from '../sidenav/sidenav.service';
import { AppLoaderData } from './models/app-loader-data.model';

export const appLoaderResolver: ResolveFn<AppLoaderData> = (route: ActivatedRouteSnapshot): Observable<AppLoaderData> => {
  const sidenavService = inject(SidenavService);

  const code = route.paramMap.get('code');
  const queryParams = route.queryParams;

  if (!code) {
    return of({ queryParams });
  }

  return sidenavService.getNavigationData().pipe(
    filter(data => !!data),
    map(navigationData => {
      const navigationDescription = findNavigationItemByCode(navigationData.NavigationItems, code)?.Description;
      const uri = environment.mfeUrls[navigationDescription] ?? navigationDescription;
      return { uri, queryParams };
    })
  );
};

function findNavigationItemByCode(items: NavigationMenuItemDto[], code: string): NavigationMenuItemDto | null {
  for (const item of items) {
    if (item.Code === code || item.State === `/next/app/${code}`) {
      return item;
    }

    if (item.HasChildren && item.Children?.length) {
      const found = findNavigationItemByCode(item.Children, code);
      if (found) {
        return found;
      }
    }
  }

  return null;
}
